import { useEffect, useState } from 'react';
import { naturalCompare } from './utils';

/**
 * The bookable products of one facility, as select options `{ value, label }`.
 *
 * Used where a resource's product is picked: product names repeat across
 * facilities (most are just "Badmintonbane"), so a search over every product
 * cannot tell which one is meant, while a facility has only a handful.
 *
 * `null` while loading or without a facility.
 */
export function useFacilityProducts(api, facilityId) {
  const [options, setOptions] = useState(null);

  useEffect(() => {
    setOptions(null);
    if (!facilityId) return;

    let current = true;
    api.products.getBookableProductsOfFacility(facilityId)
      .then(rows => {
        if (!current) return;
        setOptions((rows || [])
          .map(row => ({ value: row.id, label: row.name }))
          .sort((a, b) => naturalCompare(a.label, b.label)));
      })
      .catch(() => current && setOptions([]));

    return () => { current = false; };
  }, [api, facilityId]);

  return options;
}
